/**
 * Event Services
 * Services for event management operations
 */
// Export all service classes
export { EventService } from './EventService';
export { EventTypeService } from './EventTypeService';
export { EventStatusService } from './EventStatusService';
export { EventVendorStatusService } from './EventVendorStatusService';
export { EventVendorRegistrationService } from './EventVendorRegistrationService';
export { EventVendorSettingService } from './EventVendorSettingService';
export { ShopService } from './ShopService';
// Import for factory function
import { EventService } from './EventService';
import { EventTypeService } from './EventTypeService';
import { EventStatusService } from './EventStatusService';
import { EventVendorStatusService } from './EventVendorStatusService';
import { EventVendorRegistrationService } from './EventVendorRegistrationService';
import { EventVendorSettingService } from './EventVendorSettingService';
import { ShopService } from './ShopService';
/**
 * Create all event services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all event services
 */
export function createEventServices(http, config) {
    return {
        event: new EventService(http, config),
        eventType: new EventTypeService(http, config),
        eventStatus: new EventStatusService(http, config),
        eventVendorStatus: new EventVendorStatusService(http, config),
        eventVendorRegistration: new EventVendorRegistrationService(http, config),
        eventVendorSetting: new EventVendorSettingService(http, config),
        shop: new ShopService(http, config),
    };
}
//# sourceMappingURL=index.js.map